import React from 'react'

const ArticleV2VideoFile = ({video}) => {
    return (
        <div>
            <video src={video?.file?.url} controls></video>

            <style jsx>{`
                video {
                    width: 100%;
                    margin-bottom: 2.5rem;
                }
            `}</style>
        </div>
    )
}

export default ArticleV2VideoFile